export default __webpack_public_path__ + "static/media/lab2.980398cb.jpg";